exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "select[data-v-05e8c3e6]{padding-left:.5rem}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Users/EditUserRole.vue"],"names":[],"mappings":"AACA,wBACI,kBAAqB,CACxB","file":"EditUserRole.vue","sourcesContent":["\nselect[data-v-05e8c3e6] {\n    padding-left: 0.5rem;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e8c3e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Users/EditUserRole.vue
// module id = 2152
// module chunks = 8